




























































import Vue from 'vue'
import { PortalTarget } from 'portal-vue'
import * as Sentry from '@sentry/browser'
import EmailVerifyModal from '@/components/modal/EmailVerifyModal.vue'
import ProfileModal from '@/components/modal/ProfileModal/ProfileModal.vue'
import KarteModal from '@/components/modal/KarteModal/KarteModal.vue'
import SimpleModalWithProps from '@/components/modal/basics/SimpleModal/SimpleModalWithProps.vue'
import LoadingCoverPortal from '@/components/globals/basics/Loading/LoadingCoverPortal.vue'
import PasswordChangeWarningModal from '@/components/modal/PasswordChangeWarningModal.vue'
import SearchByNameModal from '@/components/modal/SearchFacilityModal/SearchByNameModal.vue'
import AreaByPrefectureModal from '@/components/modal/AreaModal/AreaByPrefectureModal.vue'
import SearchFacilityDetailModal from '@/components/modal/SearchFacilityModal/SearchFacilityDetailModal.vue'
import GradeNotificationModal from '@/components/modal/GradeNotificationModal/GradeNotificationModal.vue'
import {
  setSearchHistory,
  AreaId,
  AreasByPref,
  Area,
  SearchParams,
  queryToSearchHistory,
  getNameSearchHistories,
  useFacilitiesMetadataStore,
  conditionsToPath,
} from '@/core/Facilities'
import { Activity } from '@/core/Activities'
import { getGradeNotification, GradeNotificationType } from '@/core/Me'
import { Grade } from '@/core/Grades'
import { Route } from 'vue-router'
import { PartialAuthUser } from './store/modules/auth/getters'
import { GradeProgress } from './core/Auth'

const facilitiesMetadataStore = useFacilitiesMetadataStore()

export default Vue.extend({
  components: {
    EmailVerifyModal,
    ProfileModal,
    KarteModal,
    PasswordChangeWarningModal,
    SimpleModalWithProps,
    PortalTarget,
    LoadingCoverPortal,
    SearchByNameModal,
    AreaByPrefectureModal,
    SearchFacilityDetailModal,
    GradeNotificationModal,
  },
  data() {
    return {
      facilityNameSearchHistories: getNameSearchHistories(),
      gradeNotificationType: null as GradeNotificationType | null,
      gradeNotificationTarget: null as Grade | null,
      isGradeNotificationAfterProfileUpdate: false,
    }
  },
  computed: {
    isLoggedIn(): boolean {
      return this.$store.getters['auth/isLogin']
    },
    user(): PartialAuthUser {
      return this.$store.getters['auth/user']
    },
    progress(): GradeProgress | null {
      return this.$store.getters['auth/progress']
    },
    currentGrade(): Grade | null {
      return this.progress ? this.progress.currentGrade : null
    },
    hasPasswordWarning(): boolean {
      return this.$store.getters['auth/passwordWarning']
    },
    fullActivityList(): Activity[] {
      return facilitiesMetadataStore.getActivities()
    },
    areasByPref(): AreasByPref[] {
      return facilitiesMetadataStore.getAreasByPref()
    },
    areas(): Area[] {
      return facilitiesMetadataStore.getAreas()
    },
    facilitySearchValues(): SearchParams {
      return queryToSearchHistory(this.$route.query)
    },
  },
  async created() {
    await facilitiesMetadataStore.fetch()

    this.checkGradeNotification(this.$route)

    this.$router.beforeEach((to, _, next) => {
      this.checkGradeNotification(to)
      next()
    })
  },
  methods: {
    updateSearchHistory(): void {
      this.facilityNameSearchHistories = getNameSearchHistories()
    },
    onSearchByName(facilityName: string) {
      this.$modal.pop()

      // 検索履歴を保持
      setSearchHistory({
        facilityName,
      })

      // 検索履歴を更新
      this.updateSearchHistory()

      // 検索結果に遷移
      this.$router
        .push(
          conditionsToPath(
            {
              facilityName,
            },
            this.areasByPref
          )
        )
        .catch(() => {})
    },
    onSearchByAreas(areaIds: AreaId[]) {
      this.$modal.pop()

      // 検索履歴を保持
      setSearchHistory({
        areaIds,
      })

      // 検索履歴を更新
      this.updateSearchHistory()

      // 検索結果に遷移
      this.$router
        .push(conditionsToPath({ areaIds }, this.areasByPref))
        .catch(() => {})
    },
    onDetailSearch(params: SearchParams) {
      this.$modal.pop()

      // 検索履歴を保持
      setSearchHistory(params)

      // 検索結果に遷移
      this.$router
        .push(conditionsToPath(params, this.areasByPref))
        .catch(() => {})
    },
    openInitialGradeNotification() {
      if (!this.isLoggedIn) return

      this.isGradeNotificationAfterProfileUpdate = true
      this.gradeNotificationType = GradeNotificationType.GRADE_UP
      this.gradeNotificationTarget = this.currentGrade
      this.$modal.push('GradeNotificationModal')
    },
    async checkGradeNotification(route: Route) {
      if (!this.isLoggedIn) return
      if (route.path !== '/' && route.path !== '/me') return

      try {
        const notification = await getGradeNotification()
        if (!notification) return

        this.isGradeNotificationAfterProfileUpdate = false
        this.gradeNotificationType = notification.type

        switch (notification.type) {
          case GradeNotificationType.GRADE_UP:
          case GradeNotificationType.GRADE_DOWN:
          case GradeNotificationType.ACHIEVEMENT:
          case GradeNotificationType.WELCOME_BACK:
            this.gradeNotificationTarget = notification.afterGrade
            break
          default:
            return
        }

        this.$modal.push('GradeNotificationModal')
      } catch (e) {
        Sentry.captureException(e)
      }
    },
  },
})
